export default __webpack_public_path__ + "static/media/investV2.32fb5b5d.svg";